import { default as axios } from '../utils/axios.instances' // eslint-disable-line

const axiosInstance = axios.getSTAxios() // eslint-disable-line

export default {

  loadProcessors (owner) {
    return new Promise((resolve, reject) => {
      axiosInstance.get(`/locations/?type=processing&owner=${owner || ''}`).then((res) => {
        resolve(res.data.results)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  loadFarms (search) {
    return new Promise((resolve, reject) => {
      axiosInstance.get(`/locations/?type=farm&search=${search || ''}`).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  loadPackagingPlant () {
    return new Promise((resolve, reject) => {
      axiosInstance.get('/locations/?type=packaging').then((res) => {
        resolve(res.data.results)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  updateFarm (farm) {
    return new Promise((resolve, reject) => {
      axiosInstance.patch(`/locations/${farm.id}/`, farm).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  createFarm (farm) {
    return new Promise((resolve, reject) => {
      axiosInstance.post('/locations/', farm).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  }

}
